import * as React from 'react';
import { connectStateResults } from 'react-instantsearch-core';

import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';

import Retracked from 'js/app/retracked';
import connectToRouter from 'js/lib/connectToRouter';
import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { getNumberOfSearchResults } from 'bundles/search-common/utils/SearchUtils';

import _t from 'i18n!nls/coursera-plus';

import 'css!./__styles__/InPageNumberOfResultsSection';

type InputProps = {
  limitNumberOfResults: number;
  currentTab: string;
};

export type Props = {
  query: Record<string, any>;
  searching: boolean;
  searchState: any;
  allSearchResults: Record<string, any>;
} & InputProps;

export class NumberOfResultsSection extends React.Component<Props> {
  static contextTypes = {
    _eventData: PropTypes.object,
  };

  declare context: LegacyContextType<typeof NumberOfResultsSection.contextTypes>;

  componentDidUpdate(prevProps: $TSFixMe) {
    const { allSearchResults, searchState, currentTab } = this.props;
    const { _eventData } = this.context;
    const query = searchState?.query;

    const { query: currentUrlData } = this.props;
    const { query: prevUrlData } = prevProps;

    const currentNumberOfHits = getNumberOfSearchResults(currentTab, allSearchResults);

    // Because the algolia search state data will update several times on each query update, we use the url change mechanism to track it only once
    if (currentUrlData !== prevUrlData) {
      Retracked.trackComponent(
        _eventData,
        /* eslint-disable-next-line camelcase  */
        { total_number_of_search_results: currentNumberOfHits, query },
        'total_number_of_search_results',
        'search'
      );
    }
  }

  renderMessage() {
    const { searchState, searching, allSearchResults, currentTab, limitNumberOfResults } = this.props;

    if (!allSearchResults) {
      return null;
    } else if (searching) {
      return _t('Loading search results...');
    }

    const query = searchState?.query;
    const numberOfHits = getNumberOfSearchResults(currentTab, allSearchResults);

    if (numberOfHits) {
      return (
        <FormattedMessage
          message={
            query
              ? _t('Showing {limitNumberOfResults} of {numberOfHits} total results for "{query}"')
              : _t('Showing {numberOfHits} total results')
          }
          limitNumberOfResults={Math.min(limitNumberOfResults, numberOfHits)}
          numberOfHits={numberOfHits}
          query={query}
        />
      );
    } else {
      return (
        <FormattedMessage
          message={query ? _t('No results found for "{query}"') : _t('No results found for your search')}
          query={query}
        />
      );
    }
  }

  render() {
    return (
      <h3
        data-e2e="NumberOfResultsSection"
        className="rc-NumberOfResultsSection body-2-text"
        role="status"
        aria-live="polite"
      >
        {this.renderMessage()}
      </h3>
    );
  }
}

export default compose<Props, InputProps>(
  connectStateResults,
  connectToRouter((router) => ({
    query: router.location.query || '',
  }))
)(NumberOfResultsSection);
